export const LS_GUEST_COOKIE = 'flashChat_guestCookie';
export const QB_TOKEN = 'flashChat_qbToken';
